<template>
  <div class="app-body">
    <el-tabs v-model="currentTab" type="card">
      <el-tab-pane label="发票单" name="receiptTable">
        <ReceiptTable v-if="currentTab==='receiptTable'" :receipt-type="receiptType"></ReceiptTable>
      </el-tab-pane>
      <el-tab-pane label="发票明细" name="receiptDetailTable">
        <ReceiptDetailTable v-if="currentTab==='receiptDetailTable'" :receipt-type="receiptType"></ReceiptDetailTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReceiptDetailTable from '@/views/modules/erp/receipt/manager/receipt-detail-table.vue'
import ReceiptTable from '@/views/modules/erp/receipt/manager/receipt-table.vue'

/**
 * 账单/发票管理,显示主表内容
 * 使用角色:业务员(查看,审核),财务(查看,审核),工厂(查看自己的数据,创建,撤回)
 */
export default {
  name: 'receipt-manager',
  components: { ReceiptTable,ReceiptDetailTable },
  data () {
    return {
      pageType: '',
      currentTab: 'receiptTable',
      receiptType: ''
    }
  },

  activated () {
    this.receiptType = this.$route.params.type
  },
  methods: {}
}
</script>

<style scoped>

</style>
